import { render } from "./ProviderBanks.vue?vue&type=template&id=8576cd7e"
import script from "./ProviderBanks.vue?vue&type=script&lang=js"
export * from "./ProviderBanks.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__